import type { ReactNode } from 'react';
import { P } from '@workramp/ui';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { WithWordWrapCss } from '~/styled-components/common/text';

interface AwardedAcademyCertificationLearnerNameProps {
  usesCustomFont: boolean;
  children: ReactNode;
  isModalVisible?: boolean;
}

export const AwardedAcademyCertificationLearnerName = ({
  usesCustomFont,
  children,
  isModalVisible,
}: AwardedAcademyCertificationLearnerNameProps) => {
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const [fontSize, setFontSize] = useState(10);

  useEffect(() => {
    makeFontFitContainer();
  }, [isModalVisible, fontSize]);

  const makeFontFitContainer = () => {
    const container = containerRef.current;
    const textElement = textRef.current;
    setTimeout(() => {
      if (textElement.clientHeight > container.clientHeight) {
        setFontSize((prevFontSize) => prevFontSize - 1);
      }
    }, 100);
  };

  return (
    <StyledCertV2LearnerName
      size={fontSize}
      weight="bold"
      className="custom_font"
      $usesCustomFont={usesCustomFont}
      ref={containerRef}
    >
      <span ref={textRef} className="learner-name">
        {children}
      </span>
    </StyledCertV2LearnerName>
  );
};

const StyledCertV2LearnerName = styled(P)<{ $usesCustomFont: boolean }>`
  max-width: 75%;
  margin-bottom: 1.5rem;
  ${WithWordWrapCss}
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 30%;
  font-family: ${({ $usesCustomFont }) => ($usesCustomFont ? 'inherit' : `'Herr Von Muellerhoff' !important`)};
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
